module.exports = __webpack_public_path__ + "static/img/layout2.8146bdc2.png";